import { render, staticRenderFns } from "./AddOrEditScrapType.vue?vue&type=template&id=301cf548&scoped=true"
import script from "./AddOrEditScrapType.vue?vue&type=script&lang=ts"
export * from "./AddOrEditScrapType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301cf548",
  null
  
)

export default component.exports